import { render } from "./ListaContatti.vue?vue&type=template&id=db792dc2&scoped=true"
import script from "./ListaContatti.vue?vue&type=script&lang=js"
export * from "./ListaContatti.vue?vue&type=script&lang=js"

import "./ListaContatti.vue?vue&type=style&index=0&id=db792dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db792dc2"]])

export default __exports__